module.exports = __webpack_public_path__ + "img/pro_capture10.298cba31.png";